/** FF005 口座振込同意書 — admin section title */
export const BANK_ACCOUNT_SECTION_TITLE = '口座振込';
